import React from 'react';
import { PolymorphicComponentProps } from 'types';
import { useDialog } from '../DialogContext';

interface BaseDialogTitleProps {
  children?: React.ReactNode;
}

export type DialogTitleProps<As extends React.ElementType = 'span'> =
  PolymorphicComponentProps<BaseDialogTitleProps, As>;

function DialogTitle<As extends React.ElementType = 'span'>({
  as,
  children,
  ...props
}: DialogTitleProps<As>): React.ReactElement | null {
  const { titleProps } = useDialog();

  const Component: React.ElementType = as ?? 'div';

  return (
    <Component {...props} {...titleProps}>
      {children}
    </Component>
  );
}

export default DialogTitle;
